module.exports = __webpack_public_path__ + "static/media/seminarraum_jay_01_compr.556bc00e.jpg";